
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_14iqq_wvh8f_97",
  "variant-default": "awsui_variant-default_14iqq_wvh8f_109",
  "variant-stacked": "awsui_variant-stacked_14iqq_wvh8f_109",
  "header": "awsui_header_14iqq_wvh8f_132",
  "header-sticky-disabled": "awsui_header-sticky-disabled_14iqq_wvh8f_136",
  "header-sticky-enabled": "awsui_header-sticky-enabled_14iqq_wvh8f_140",
  "header-stuck": "awsui_header-stuck_14iqq_wvh8f_146",
  "header-dynamic-height": "awsui_header-dynamic-height_14iqq_wvh8f_151",
  "with-paddings": "awsui_with-paddings_14iqq_wvh8f_157",
  "header-variant-cards": "awsui_header-variant-cards_14iqq_wvh8f_160",
  "header-variant-full-page": "awsui_header-variant-full-page_14iqq_wvh8f_184",
  "dark-header": "awsui_dark-header_14iqq_wvh8f_192",
  "content": "awsui_content_14iqq_wvh8f_196",
  "footer": "awsui_footer_14iqq_wvh8f_203",
  "with-divider": "awsui_with-divider_14iqq_wvh8f_206"
};
  